import { graphql, Link } from "gatsby";
import * as React from "react";

import {
  AboutUsLanguages,
  ServiceLanguages,
  TheBakeryLanguages,
} from "../../../../company/settings/translations";
import DropdownMenu from "../../modules/DropdownMenu/DropdownMenu";
import { getSlugWithLang } from "../../modules/Shared/Utils/getSlugWithLang";
import { ISliceProps } from "../../types/thecookies";

const MainMenu: React.FC<ISliceProps<Queries.MainMenuQuery>> = (
  props: ISliceProps<Queries.MainMenuQuery>,
) => {
  const { language } = props.sliceContext;
  return (
    <>
      <Link
        to={getSlugWithLang(`/#${ServiceLanguages[language]?.slug}`, language)}
        activeClassName={"navbarlinks--active"}
        className={"navbarlinks__item"}
      >
        {ServiceLanguages[language]?.name}
      </Link>
      <Link
        to={getSlugWithLang(`#${AboutUsLanguages[language]?.slug}`, language)}
        activeClassName={"navbarlinks--active"}
        className={"navbarlinks__item"}
      >
        {AboutUsLanguages[language]?.name}
      </Link>
      <Link
        to={getSlugWithLang(TheBakeryLanguages[language]?.slug, language)}
        activeClassName={"navbarlinks--active"}
        className={"navbarlinks__item"}
      >
        {TheBakeryLanguages[language]?.name}
      </Link>
      <DropdownMenu
        menuItems={props.data.allSanityKitDigital?.nodes.map((node) => ({
          name: node.name,
          slug: node.slug,
        }))}
        buttonText={"Kit Digital"}
      />
    </>
  );
};

export default MainMenu;

export const query = graphql`
  query MainMenu($language: String!) {
    allSanityKitDigital(filter: { language: { eq: $language } }) {
      nodes {
        name
        slug
      }
    }
  }
`;
